import $ from 'jquery';

export const setDefaultAltText = () => {
  $('img:not([alt])').attr('alt', '')
};


// WEBPACK FOOTER //
// ./scripts/lib/dom/images.js